import { render, staticRenderFns } from "./HeartOutlinedIcon.vue?vue&type=template&id=ca6b7582&"
import script from "./HeartOutlinedIcon.vue?vue&type=script&lang=js&"
export * from "./HeartOutlinedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports